import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import Swal from "sweetalert2";
import VehicleServices from '../../../services/VehicleServics'; // Ensure the import path is correct
import StoreServices from '../../../services/LocationServices'; // For fetching store data

const VehicleEdit = ({ item,show,test, handleClose  }) => {
  const [formValues, setFormValues] = useState({
    name: '',
    category: '',
    rentalStatus: '',
    capacity: '',
    assignedStore: '',
    average:'',
  });

  const [stores, setStores] = useState([]); // Stores data for dropdown
  const [categories, setCategories] = useState([]); // Vehicle categories

  // Fetch store data when the modal opens
  useEffect(() => {
    const fetchStores = async () => {
      try {
        const response = await StoreServices.getStore();
        if (response.data.data) {
          setStores(response.data.data);
        }
      } catch (error) {
        console.error('Failed to fetch stores', error);
      }
    };
    fetchStores();
  }, []);

  // Fetch categories when the modal opens
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await VehicleServices.getAllCategory(); // Fetch categories from the API
        if (response.data.data) {
          setCategories(response.data.data); // Set the fetched categories in state
        }
      } catch (error) {
        console.error('Failed to fetch categories', error);
      }
    };
    fetchCategories();
  }, []);

  // Populate the form with the vehicle data when the modal opens
  useEffect(() => {
    if (item) {
      setFormValues({
        name: item.name || '',
        category: item.category ? item.category._id : '',  // Set category _id if it exists
        rentalStatus: item.rentalStatus || '',
        capacity: item.capacity || '',
        assignedStore: item.assignedStore ? item.assignedStore._id : '',  // Set store _id if it exists
        average:item.average
      });
    }
  }, [item]); // Re-run when item changes

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (!formValues.name || !formValues.category || !formValues.rentalStatus || !formValues.capacity || !formValues.assignedStore) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'All fields are required!',
      });
      return;
    }
  
    try {
      const response = await VehicleServices.updateVehicle(item._id, formValues);
      console.log(response);
  
      if (response.status === 200) {
        test();
        handleClose();
        Swal.fire({
          icon: "success",
          title: "Good job!",
          text: "Vehicle details have been successfully updated!",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: response.data.message || "An error occurred while updating.",
        });
      }
    } catch (error) {
      console.error('Failed to update vehicle details', error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to update vehicle details.",
      });
    }
  };
  

  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title><i className="fas fa-edit"></i> Edit Vehicle Details</Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6" className="mb-3">
                <label>Vehicle Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control form-control-sm"
                  placeholder="Enter vehicle name"
                  value={formValues.name}
                  onChange={handleInputChange}
                  required
                />
              </Col>
              <Col md="6" className="mb-3">
                <label>Category</label>
                <select
                  name="category"
                  className="form-control form-control-sm"
                  value={formValues.category}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map((category) => (
                    <option key={category._id} value={category._id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="mb-3">
                <label>Rental Status</label>
                <select
                  name="rentalStatus"
                  className="form-control form-control-sm"
                  value={formValues.rentalStatus}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Rental Status</option>
                  <option value="Purchased">Purchased</option>
                  <option value="Rented">Rented</option>
                </select>
              </Col>
              <Col md="6" className="mb-3">
                <label>Capacity</label>
                <input
                  type="number"
                  name="capacity"
                  className="form-control form-control-sm"
                  placeholder="Enter capacity (e.g., diesel capacity)"
                  value={formValues.capacity}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="mb-3">
                <label>Assigned Store</label>
                <select
                  name="assignedStore"
                  className="form-control form-control-sm"
                  value={formValues.assignedStore}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Store</option>
                  {stores.map((store) => (
                    <option key={store._id} value={store._id}>
                      {store.name}
                    </option>
                  ))}
                </select>
              </Col>
              <Col md="6" className="mb-3">
                <label>Average</label>
                <input
                  type="number"
                  name="average"
                  className="form-control form-control-sm"
                  placeholder="Enter capacity (e.g., diesel capacity)"
                  value={formValues.average}
                  onChange={handleInputChange}
                  required
                />
              
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" type="submit">
            Save Changes
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default VehicleEdit;
